import React from 'react';

interface BoardsContextType {
  // Active (non-archived) boards. Does not include boards with isHidden: true.
  boards: (PerformanceBoardTypes.Board | Board)[];
  // Boards with isHidden: true. Only exposed for the staff-only Archived view.
  archivedBoards: (PerformanceBoardTypes.Board | Board)[];
}

const BoardsContext = React.createContext<BoardsContextType>({
  boards: [],
  archivedBoards: [],
} as BoardsContextType);

export default BoardsContext;
